import React, { useEffect, useState } from "react";
import api, { errMsg } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { EmptyState } from "@/components/EmptyState";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bell, CheckCheck, Loader2, Inbox } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.notifications); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const readAll = async () => {
    try { await api.post("/notifications/read-all"); toast.success("All marked as read"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  const timeAgo = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return ""; } };

  return (
    <div className="max-w-2xl mx-auto">
      <PageHeader title="Notifications" subtitle="Stay on top of offers, connections and messages." action={items.some((n) => !n.read) && <Button variant="outline" onClick={readAll} className="rounded-full" data-testid="notif-read-all"><CheckCheck className="w-4 h-4" /> Mark all read</Button>} />
      {loading ? <div className="flex justify-center py-16"><Loader2 className="w-7 h-7 text-primary animate-spin" /></div> : items.length === 0 ? (
        <EmptyState icon={Inbox} title="No notifications yet." description="We'll let you know when something happens." testid="empty-notifications" />
      ) : (
        <div className="space-y-2" data-testid="notifications-list">
          {items.map((n) => (
            <button key={n.id} onClick={() => { readOne(n.id); if (n.link) window.location.href = n.link; }} data-testid={`notification-${n.id}`}
              className={`w-full text-left flex items-start gap-3 p-4 rounded-2xl border transition-colors ${n.read ? "bg-white border-slate-200" : "bg-accent/60 border-primary/20"}`}>
              <div className="w-9 h-9 rounded-xl bg-white border border-slate-200 flex items-center justify-center flex-shrink-0"><Bell className="w-4 h-4 text-primary" /></div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-slate-800">{n.title}</p>
                <p className="text-sm text-slate-500">{n.body}</p>
                <p className="text-xs text-slate-400 mt-1">{timeAgo(n.created_at)}</p>
              </div>
              {!n.read && <span className="w-2.5 h-2.5 rounded-full bg-primary mt-1.5" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
